import { Tag } from "../common/tag";
import { FileCreateDto } from "../ui-models/files";

export class CoverLetter {
  id: string;
  title: string;
  fileName: string;
  tags: Tag[];
  isDefault: boolean;
  createdOn: Date;

  constructor(data: Partial<CoverLetter>) {
    this.id = data.id ?? '';
    this.title = data.title ?? '';
    this.fileName = data.fileName ?? '';
    this.tags = data.tags?.map(t => new Tag(t)) ?? [];
    this.isDefault = data.isDefault ?? false;
    this.createdOn = data.createdOn ? new Date(data.createdOn) : new Date();
  }
}

export class CoverLetterCreateModel {
  title: string;
  file: FileCreateDto;
  tagIds: string[];

  constructor(data: Partial<CoverLetterCreateModel> = {}) {
    this.title = data.title ?? '';
    this.tagIds = data.tagIds ?? [];
    this.file = data.file!;
  }
}
